export const deData = {
  title: "Datenschutz- und Cookie-Richtlinie – Danghuan",
  sections: [
    {
      title: "Einleitung",
      content: `
        <p>Diese Datenschutz- und Cookie-Richtlinie erläutert, wie Danghuan Europe S.L. („wir“, „uns“ oder „Danghuan“) Ihre personenbezogenen Daten erhebt, verwendet und schützt, wenn Sie mit unseren Websites und Diensten interagieren. Diese Richtlinie gilt für Einwohner des Europäischen Wirtschaftsraums (EWR) und des Vereinigten Königreichs (UK) und entspricht den Anforderungen der Datenschutz-Grundverordnung (DSGVO) und der UK-Datenschutz-Grundverordnung (UK GDPR).</p>
      `
    },
    {
      title: "Geltungsbereich dieser Richtlinie",
      content: `
        <p>Diese Richtlinie gilt für:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Besucher unserer Website (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Kunden und potenzielle Kunden</li>
          <li style='margin-bottom: 8px;'>Nutzer unserer Trade-In- und Wiederverkaufsdienste</li>
          <li style='margin-bottom: 8px;'>Vertreter von Geschäftspartnern und Plattform-Partnerunternehmen</li>
        </ul>
      `
    },
    {
      title: "Welche Daten wir erheben",
      content: `
        <p>Je nach Art Ihrer Interaktion mit uns können wir folgende personenbezogene Daten erheben:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Vollständiger Name, Anschrift, E-Mail-Adresse und Telefonnummer</li>
          <li style='margin-bottom: 8px;'>IBAN, Sort Code und Kontonummer, PayPal-, Revolut- oder andere Bankverbindungsdaten</li>
          <li style='margin-bottom: 8px;'>Gerätedetails (Modell, Marke, Zustand, Preisinformationen, IMEI)</li>
          <li style='margin-bottom: 8px;'>Kommunikationsverlauf mit dem Kundendienst</li>
          <li style='margin-bottom: 8px;'>Marketingpräferenzen und Interaktionen mit Kampagnen</li>
          <li style='margin-bottom: 8px;'>IP-Adresse, Browsertyp, Sitzungs-ID und Standort</li>
          <li style='margin-bottom: 8px;'>Plattformdaten von Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Wir können bestimmte Daten auch über unsere Plattform- oder Logistikpartner (z. B. Shopify, Amazon, Back Market, TEMU) erhalten, wenn Sie über deren Plattformen mit unseren Diensten interagieren. Diese Daten können Bestellinformationen, Versandadressen und Transaktionsstatus umfassen.</p>
      `
    },
    {
      title: "Verwendung personenbezogener Daten",
      content: `
        <p>Wir verwenden Ihre personenbezogenen Daten, um die folgenden Zwecke zu erfüllen:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Bearbeitung von Bestellungen und Verwaltung der Logistik, einschließlich Rücksendungen und Trade-In-Prozesse</li>
          <li style='margin-bottom: 8px;'>Kommunikation mit Ihnen in Bezug auf Ihre Transaktionen und Serviceanfragen</li>
          <li style='margin-bottom: 8px;'>Bereitstellung von Kundendienst und technischem Support</li>
          <li style='margin-bottom: 8px;'>Versand von Marketingmitteilungen (sofern Sie dem ausdrücklich zugestimmt haben)</li>
          <li style='margin-bottom: 8px;'>Einhaltung gesetzlicher Verpflichtungen, z. B. Steuer-, Buchhaltungs- oder Betrugsprüfungen</li>
          <li style='margin-bottom: 8px;'>Verbesserung der Benutzererfahrung und Optimierung unserer Plattformen und Services</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Wir verwenden Cookies, um Ihr Browser-Erlebnis zu verbessern und unsere Dienste zu optimieren. Cookies können folgende Informationen erfassen:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP-Adresse und Geolokalisierung</li>
          <li style='margin-bottom: 8px;'>Browser- oder Gerätekennungen</li>
          <li style='margin-bottom: 8px;'>Nutzungsverhalten (z. B. besuchte Seiten, Verweildauer, Klicks)</li>
        </ul>
        <p>Arten von Cookies:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Strikt erforderliche Cookies</li>
          <li style='margin-bottom: 8px;'>Funktionale Cookies</li>
          <li style='margin-bottom: 8px;'>Leistungs- / Performance-Cookies</li>
          <li style='margin-bottom: 8px;'>Werbe- / Targeting-Cookies</li>
        </ul>
        <p>Sie können Ihre Cookie-Einstellungen jederzeit über die Einstellungen Ihres Browsers oder über das Cookie-Banner auf unserer Website anpassen oder widerrufen.</p>
      `
    },
    {
      title: "Weitergabe an Dritte",
      content: `
        <p>Wir geben Daten nur an Dritte weiter, soweit dies zur Vertragserfüllung erforderlich oder von Ihrer Einwilligung gedeckt ist. Empfänger können sein:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Zahlungspartner: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistikdienstleister: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Plattformpartner: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Marketing- und Analysepartner: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT-Dienstleister, Berater und Rechtsanwälte</li>
          <li style='margin-bottom: 8px;'>Behörden, sofern gesetzlich vorgeschrieben</li>
        </ul>
        <p>Datenübermittlungen außerhalb des EWR / UK erfolgen ausschließlich auf Grundlage geeigneter Garantien, etwa der EU-Standardvertragsklauseln.</p>
      `
    },
    {
      title: "Verwendung von Marken- und Logos Dritter",
      content: `
        <p>Unsere Website zeigt Marken- und Logos (z. B. Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google u. a.) ausschließlich zur Identifikation kompatibler Geräte für Trade-In- oder Wiederverkaufszwecke. Alle Marken gehören ihren jeweiligen Eigentümern. Danghuan Europe ist ein unabhängiger Dienstleister, nicht mit diesen Marken verbunden und weder autorisiert noch gesponsert, außer wenn ausdrücklich angegeben.</p>
        <p>Die Darstellung der Logos dient allein beschreibenden Zwecken; sämtliche Markenrechte verbleiben bei den jeweiligen Inhabern.</p>
      `
    },
    {
      title: "Datenspeicherung und Sicherheit",
      content: `
        <p>Wir speichern Ihre Daten nur so lange, wie es zur Erfüllung der oben genannten Zwecke oder gesetzlich erforderlich ist. Wir treffen geeignete technische und organisatorische Maßnahmen zum Schutz Ihrer Daten – einschließlich Verschlüsselung, Zugriffskontrolle und sicherer Speicherung.</p>
      `
    },
    {
      title: "Ihre Rechte",
      content: `
        <p>Wir beantworten berechtigte Anfragen innerhalb eines Monats. Zum Schutz Ihrer Privatsphäre müssen wir ggf. Ihre Identität verifizieren.</p>
        <p>Sie haben das Recht:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Auf Auskunft und Berichtigung Ihrer Daten</li>
          <li style='margin-bottom: 8px;'>Auf Löschung („Recht auf Vergessenwerden“)</li>
          <li style='margin-bottom: 8px;'>Der Verarbeitung zu widersprechen oder sie einzuschränken</li>
          <li style='margin-bottom: 8px;'>Ihre Einwilligung jederzeit zu widerrufen</li>
          <li style='margin-bottom: 8px;'>Die Datenübertragbarkeit zu verlangen (soweit anwendbar)</li>
        </ul>
        <p>Zur Ausübung dieser Rechte kontaktieren Sie uns bitte unter <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Aktualisierungen dieser Richtlinie",
      content: `
        <p>Wir können diese Richtlinie anpassen, um Änderungen rechtlicher Anforderungen oder interner Datenpraktiken widerzuspiegeln. Die jeweils aktuelle Version finden Sie jederzeit auf unserer Website.</p>
      `
    },
    {
      title: "Kontakt",
      content: `
        <p>Bei Fragen oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Danghuan Europe S.L.</li>
          <li style='margin-bottom: 8px;'>E-Mail: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'>Website: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Sie können außerdem eine Beschwerde bei Ihrer zuständigen nationalen Datenschutzaufsichtsbehörde oder bei der Spanischen Datenschutzbehörde (Agencia Española de Protección de Datos – AEPD) einreichen.</p>
      `
    },
    {
      title: "Anhang – Erweiterte rechtliche und Cookie-Informationen",
      subsections: [
        {
          title: "1. Rechtsgrundlagen der Datenverarbeitung",
          content: `
            <p>Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Basis von:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Vertragserfüllung (z. B. Bearbeitung von Trade-In-Bestellungen, Zahlungsabwicklung)</li>
              <li style='margin-bottom: 8px;'>Gesetzlichen Pflichten (z. B. Steuer- oder Identitätsprüfung)</li>
              <li style='margin-bottom: 8px;'>Einwilligung (z. B. für Marketingkommunikation oder Cookies von Dritten)</li>
              <li style='margin-bottom: 8px;'>Berechtigtem Interesse (z. B. Betrugsprävention, interne Analysen, Serviceverbesserung)</li>
            </ul>
          `
        },
        {
          title: "2. Betrugsprävention",
          content: `
            <p>Wir können personenbezogene Informationen (z. B. Seriennummer, Transaktionsmuster, IP-Geolokation, IBAN-Inhaberschaft) zur Betrugserkennung mithilfe öffentlicher Datenbanken und Anti-Betrugs-Dienstleister nutzen. Dies erfolgt auf Grundlage unseres berechtigten Interesses, Identitätsdiebstahl und Missbrauch unserer Dienste zu verhindern.</p>
            <p>Es werden keine Entscheidungen ausschließlich auf automatisierter Verarbeitung getroffen, die Sie erheblich beeinträchtigen.</p>
          `
        },
        {
          title: "3. Datenverarbeitung auf externen Marktplätzen",
          content: `
            <p>Wenn Sie Geräte über Drittplattformen wie Amazon, Shopify, TEMU oder Back Market kaufen oder verkaufen, kann Danghuan Ihre Bestellinformationen, Versandadresse und Zahlungsbestätigung über verschlüsselte Schnittstellen (API) oder sichere Back-Office-Kanäle erhalten – ausschließlich zur Vertragsabwicklung und After-Sales-Unterstützung.</p>
          `
        },
        {
          title: "4. Cookie-Kategorien und Details",
          content: `
            <p>Eine vollständige Liste der von uns verwendeten Cookies – einschließlich Name, Anbieter, Zweck, Speicherdauer und Typ (Eigene oder Drittanbieter-Cookies) – finden Sie in der nachstehenden Tabelle. Dazu gehören Analyse-Cookies von Google Analytics, Retargeting-Cookies von Meta, sowie Zahlungs-Cookies von PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Kategorie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cookie-Name</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Anbieter</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Zweck</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Speicherdauer</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Typ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt erforderlich</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Speichert Cookie-Präferenzen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 Jahr</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Erstanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt erforderlich</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Verwaltet Sitzungszustand über Seiten hinweg</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sitzung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Erstanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktional</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Merkt sich gewählte Spracheinstellung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sitzung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Erstanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktional</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ermöglicht Live-Chat-Support</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 Monate</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Leistung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Erfasst Nutzungsstatistiken der Website</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 Jahre</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Leistung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Verfolgt Nutzerverhalten über Sitzungen hinweg</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 Stunden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Leistung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Erhält Nutzersitzung über Seiten hinweg</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 Jahr</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Werbung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Liefert personalisierte Werbung basierend auf Verhalten</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 Monate</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Werbung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Verfolgt Nutzerinteraktionen und Conversions</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 Monate</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Werbung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Verfolgt Nutzer über Websites für Marketingzwecke</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 Tag</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Werbung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Wird für Conversion-Tracking verwendet</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 Monate</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Werbung</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifiziert Besucher für E-Mail-Marketing-Kampagnen</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 Jahre</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Drittanbieter</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Aktionen, Kampagnen und Umfragen",
          content: `
            <p>Wenn Sie an unseren Aktionen, Umfragen oder Gewinnspielen teilnehmen, erheben wir ggf. Ihren Namen, Kontaktdaten und weitere veranstaltungsspezifische Informationen (z. B. Alter, Standort). Diese Daten werden ausschließlich zur Durchführung der Aktion, zur Kontaktaufnahme mit Gewinnern und zur Optimierung zukünftiger Kampagnen verwendet.</p>
          `
        },
        {
          title: "6. Aufsichtsbehörden",
          content: `
            <p>Wenn Sie der Ansicht sind, dass Ihre Datenschutzrechte verletzt wurden, können Sie eine Beschwerde bei folgenden Aufsichtsbehörden einreichen:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Im Vereinigten Königreich: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
              <li style='margin-bottom: 8px;'>In der Europäischen Union: die zuständige nationale Aufsichtsbehörde Ihres Landes über die Website des European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};